<div #backgroundImage class="background-hero-image" [ngStyle]="{ 'background-image' : 'url(' +defaultBg + ')'}">
  <div class="background-wrapper">
    <ng-container *ngIf="customerConfig$ | async as customer">
      <spinner *ngIf="customer.isLoading" fixed="true"></spinner>
      <div class="px-lg-8 px-md-8">
        <div class="container pt-4 pb-4 px-lg-10 px-md-10" *ngIf="!customer.isLoading">
          <h1 id="welcomeMessage" class="text-white pt-1">{{ welcomeUserString }} </h1>
          <ng-container *ngIf="!customer.isLoading">
            <app-homepage-tiles class="homepage-tiles-alignment"></app-homepage-tiles>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>
